import firebase from 'firebase';

import * as collections from '@/firebase/collectionTypes';

const db = firebase.firestore();
const commentsCollection = db.collection(collections.COMMENTS);


export function getPostComments(postId) {
  return commentsCollection
    .where('postId', '==', postId)
    .get()
    .then((querySnapshot) => {
      const comments = [];
      querySnapshot.forEach(doc => comments.push({ id: doc.id, ...doc.data() }));
      return comments;
    });
}

export function watchPostComments(postId, callback) {
  return commentsCollection
    .where('postId', '==', postId)
    .onSnapshot((querySnapshot) => {
      const comments = [];
      querySnapshot.forEach(doc => comments.push({ id: doc.id, ...doc.data() }));

      callback(comments);
    });
}

export function createComment(comment) {
  return commentsCollection.add(comment);
}



// WEBPACK FOOTER //
// ./src/firebase/helper.js